import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    canAssignSubgroups: false,
    subgroups: null,
    loadingSubgroups: false,
    subjects: null,
    loadingSubjects: false,
    allSubjects: null,
    loadingAllSubjects: false,
    loadingLessonsByDate: false,
    lessonsByDate: null
};

const loadSubgroups = (state) => {
    return {
        ...state,
        loadingSubgroups: true
    }
}

const setSubgroups = (state, action) => {
    return {
        ...state,
        subgroups: {...action.subgroups},
        loadingSubgroups: false
    }
}

const checkCanAssignSubgroups = (state, action) => {
    return {
        ...state,
        canAssignSubgroups: action.canAssignSubgroups
    }
}

const loadSubjects = (state) => {
    return {
        ...state,
        loadingSubjects: true
    }
}

const setSubjects = (state, action) => {
    return {
        ...state,
        subjects: [...action.subjects],
        loadingSubjects: false
    }
}

const loadAllSubjects = (state) => {
    return {
        ...state,
        loadingAllSubjects: true
    }
}

const setAllSubjects = (state, action) => {
    return {
        ...state,
        allSubjects: {...action.allSubjects},
        loadingAllSubjects: false
    }
}

const loadLessonsByDate = (state) => {
    return {
        ...state,
        loadingLessonsByDate: false
    }
}

const setLessonsByDate = (state, action) => {
    return {
        ...state,
        lessonsByDate: [...action.lessons],
        loadingLessonsByDate: false
    }
}

const omissionUpdated = (state, action) => {
    const updatedLessons = state.lessonsByDate.map(l => {
        if (l.id === action.lessonId) {
            const updatedStudents = l.students.map(s => {
                let studentDto = action.newStudentOmissions.find(dto => dto.id === s.id)
                if (studentDto) {
                    const updatedStudent = {...s};
                    updatedStudent.omission = studentDto.omission;
                    return updatedStudent;
                } else {
                    return s;
                }
            });
            const updatedLesson = { ...l };
            updatedLesson.students = updatedStudents;
            return updatedLesson;
        } else {
            return l;
        }
    })
    return {
        ...state,
        lessonsByDate: updatedLessons
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.CAN_ASSIGN_SUBGROUPS: return checkCanAssignSubgroups(state, action);
        case actionTypes.LOAD_SUBGROUPS: return loadSubgroups(state);
        case actionTypes.SET_SUBGROUPS: return setSubgroups(state, action);
        case actionTypes.LOAD_SUBJECTS_FOR_SUBGROUPS: return loadSubjects(state);
        case actionTypes.SET_SUBJECTS_FOR_SUBGROUPS: return setSubjects(state, action);
        case actionTypes.LOAD_ALL_SUBJECTS: return loadAllSubjects(state);
        case actionTypes.SET_ALL_SUBJECTS: return setAllSubjects(state, action);
        case actionTypes.LOAD_LESSONS_BY_DATE: return loadLessonsByDate(state);
        case actionTypes.SET_LESSONS_BY_DATE: return setLessonsByDate(state, action);
        case actionTypes.UPDATE_OMISSION: return omissionUpdated(state, action);
        default: return state;
    }
};
export default reducer;
